import { Box, Heading, Text, useColorModeValue } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { TONE, TYPE } from "../../styles/theme";
import { SiteFooter } from "../common/AppIntroduction";

export function PageHeader({ title, subtitle, backLabel = "← Home", onBack, align = "left", mb = { base: 8, md: 10 } }) {
  const navigate = useNavigate();
  const t = useColorModeValue(TONE.light, TONE.dark);

  return (
    <Box mb={mb} textAlign={align}>
      {backLabel && (
        <Text
          as="button" type="button" fontSize={TYPE.meta} minH="44px" color={t.dim} mb={2}
          cursor="pointer" display="inline-flex" alignItems="center" gap={1}
          _hover={{ color: t.accent }} transition="color 0.12s ease"
          onClick={onBack ?? (() => navigate("/"))}
        >
          {backLabel}
        </Text>
      )}
      {title && (
        <Heading as="h1" fontSize={TYPE.pageTitle} fontWeight={400} color={t.text} mb={subtitle ? 4 : 0}>
          {title}
        </Heading>
      )}
      {subtitle && (
        <Text fontSize={TYPE.lead} color={t.dim} lineHeight={1.65} maxW="640px" mx={align === "center" ? "auto" : 0}>
          {subtitle}
        </Text>
      )}
    </Box>
  );
}

// `narrow` is for prose (Contact, Privacy); the default width is for grids (Collections).
// Horizontal padding matches the homepage so the left edge doesn't move between pages.
export default function PageLayout({ children, narrow = false, pt, pb, transparent = false, footer = true }) {
  const bg = useColorModeValue(TONE.light.bg, TONE.dark.bg);

  return (
    <Box as="main" id="main-content" bg={transparent ? "transparent" : bg}>
      <Box
        maxW={narrow ? "720px" : "1180px"}
        mx="auto"
        px={{ base: 6, md: 10 }}
        pt={pt ?? { base: 6, md: 10 }}
        pb={pb ?? { base: 12, md: 16 }}
      >
        {children}
      </Box>
      {footer && <SiteFooter />}
    </Box>
  );
}
